import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { map } from 'rxjs/operators';
import { copyCodeDialogOpen } from './copy-code-dialog.action';
import { FEATURE_NAME } from './copy-code-dialog.constant';

@Injectable()
export class CopyCodeDialogEffect {

  private _onCopyCodeDialogOpen$ = createEffect(() => this._actions$.pipe(
    ofType(copyCodeDialogOpen),
    map((data) => zefDialogOpen({
      key: FEATURE_NAME,
      meta: data
    }))
  ));

  constructor(
    private _actions$: Actions
  ) { }
}
